module.exports = "images/teamed_image_10.png";